import { Button } from '@mui/material';
import FullModal from './FullModal';

const ConfirmModal = ({
  title = 'Confirm action',
  description = 'Are you sure you want to continue?',
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  confirmColor = 'primary',
  confirmDisabled = false,
  onConfirm,
  onClose,
  children,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm?.();
  };

  return (
    <FullModal onClose={onClose}>
      <form className="confirm-modal" onSubmit={handleSubmit}>
        <h3 className="confirm-modal__title">{title}</h3>
        {description && <p className="confirm-modal__description">{description}</p>}
        {children}
        <div className="confirm-modal__actions">
          <Button type="button" variant="outlined" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button type="submit" variant="contained" color={confirmColor} disabled={confirmDisabled}>
            {confirmLabel}
          </Button>
        </div>
      </form>
    </FullModal>
  );
};

export default ConfirmModal;
